import { API } from "src/constants";

import { Http } from "../http";

import { MenuResponse } from "./menu.types";

export const getMenu = (): MenuResponse => Http.get(`${API}/menu?code=top`);
